import type { LinkedAccount } from "@store/linkedAccountSlice";
import { IconLineActions } from "@kalodata/kds-design-icons";
import { Dropdown } from "antd";
import classNames from "classnames";
import { useState } from "react";
import { Trans } from "react-i18next";
import { DisconnectConfirmModal } from "./DisconnectConfirmModal";

interface AccountActionsMenuProps {
  account: LinkedAccount;
  className?: string;
}

export const AccountActionsMenu = ({ account, className }: AccountActionsMenuProps) => {
  const [open, setOpen] = useState(false);
  const [confirmOpen, setConfirmOpen] = useState(false);

  return (
    <>
      <Dropdown
        trigger={["hover"]}
        placement="bottomRight"
        onOpenChange={setOpen}
        menu={{
          items: [
            {
              key: "disconnect",
              label: (
                <div
                  className="flex h-full w-full items-center"
                  onClick={(e) => {
                    e.stopPropagation();
                    setConfirmOpen(true);
                  }}
                >
                  <Trans>Disconnect</Trans>
                </div>
              ),
            },
          ],
        }}
      >
        <div
          className={classNames(
            "flex size-[20px] cursor-pointer items-center justify-center text-kds-fg-soft transition-opacity",
            open ? "opacity-100" : "opacity-0 group-hover:opacity-100",
            className,
          )}
          onClick={(e) => e.stopPropagation()}
        >
          <IconLineActions size={20} />
        </div>
      </Dropdown>
      <DisconnectConfirmModal open={confirmOpen} account={account} onClose={() => setConfirmOpen(false)} />
    </>
  );
};
